import React from "react";
import { Carousel, Select } from "antd";
import { ChevronDown } from "lucide-react";
import GradientBarChart from "../pages/Graphs/GradientBarChart";
import GradientLineChart from "../pages/Graphs/GradientLineChart";
import { generateHSLGradient } from "./Colors/Colors";
import WCABubbleChart from "../pages/Graphs/WCABubbleChart";

// Define carousel slide styles
const slideStyle: React.CSSProperties = {
  height: "400px", // Adjust this height as needed
  width: "100%",
  background: "#1a1a1a",
};

interface HeaderProps {
  onOptionChange: (value: string) => void;
}

const Header: React.FC<HeaderProps> = ({ onOptionChange }) => {
  return (
    <div className="flex justify-between items-start mb-4">
      <div>
        <h1 className="text-[sm]">Category Statistics</h1>
        <p className="info-col text-[10px] 2xl:text-[12px]">
          Swipe to view category wise graph.
        </p>
      </div>
      <Select
        defaultValue="HET"
        style={{ width: 120 }}
        onChange={onOptionChange}
        suffixIcon={<ChevronDown className="text-white" size={16} />}
        className="bg-gray-800 border-gray-700 text-white"
        dropdownStyle={{
          background: "black",
          borderRadius: "8px",
        }}
      >
        <Select.Option value="HET">HET</Select.Option>
        {/* <Select.Option value="option2">Option 2</Select.Option>
        <Select.Option value="option3">Option 3</Select.Option> */}
      </Select>
    </div>
  );
};

// Example usage in your carousel:

const sampleBubbleData = [
  { id: "unfr", label: "UNFR", value: 55, x: 15, y: 40 },
  { id: "wopr", label: "WOPR", value: 45, x: 35, y: 30 },
  { id: "acre", label: "ACRE", value: 35, x: 55, y: 35 },
  { id: "ccad", label: "CCAD", value: 50, x: 75, y: 30 },
  { id: "casp", label: "CASP", value: 20, x: 10, y: 70 },
  { id: "rama", label: "RAMA", value: 25, x: 30, y: 65 },
  { id: "figo", label: "FIGO", value: 40, x: 50, y: 65 },
  { id: "acpa", label: "ACPA", value: 30, x: 70, y: 65 },
  { id: "ccco", label: "CCCO", value: 35, x: 85, y: 65 },
];

export const sampleData = [
  { name: "LASH", value: 28, ...generateHSLGradient(0) },
  { name: "TQSH", value: 48, ...generateHSLGradient(1) },
  { name: "HSEQ", value: 35, ...generateHSLGradient(2) },
  { name: "OPS", value: 42, ...generateHSLGradient(3) },
];

// Custom styles for the carousel
const carouselStyles = `
  .ant-carousel .slick-slide {
    height: 400px;
  }
  
  .ant-carousel .slick-dots {
    margin-bottom: 24px;
  }
  
  .ant-carousel .slick-prev,
  .ant-carousel .slick-next {
    color: white;
    font-size: 20px;
    width: 35px;
    height: 35px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    z-index: 2;
    display: flex !important;
    align-items: center;
    justify-content: center;
  }
  
  .ant-carousel .slick-prev {
    left: 10px;
  }
  
  .ant-carousel .slick-next {
    right: 10px;
  }
`;

const CategoryStatistics: React.FC = () => {
  const handleOptionChange = (value: string) => {
    console.log("Selected:", value);
  };

  return (
    <div className="graph-dashboard bg-[#10151A] rounded-[15px] mb-[20px] p-[30px]">
      <style>{carouselStyles}</style>
      <Header onOptionChange={handleOptionChange} />
      <div className="relative w-full h-[400px]">
        {" "}
        {/* Container with fixed height */}
        <Carousel arrows infinite={true} dots={false} className="h-full">
          <div>
            <div style={slideStyle}>
              <GradientBarChart data={sampleData} title="Del (Delivery)" />
            </div>
          </div>
          <div>
            <div style={slideStyle}>
              <GradientLineChart
                data={[
                  { name: "Type A", value: 35, color: "#FF6B6B" },
                  { name: "Type B", value: 52, color: "#4ECDC4" },
                  { name: "Type C", value: 42, color: "#4ECDC4" },
                  { name: "Type D", value: 62, color: "#4ECDC4" },
                  { name: "Type E", value: 102, color: "#4ECDC4" },
                ]}
                title="PLS (P&L)"
              />
            </div>
          </div>
          <div>
            <div style={slideStyle}>
              <WCABubbleChart
                data={sampleBubbleData}
                title="WCA (Working Capital)"
              />
            </div>
          </div>
        </Carousel>
      </div>
    </div>
  );
};

export default CategoryStatistics;
